var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2D99C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.323 1.51c2.042.187 4.047.88 5.81 2.082L.947 11.777a7.95 7.95 0 0 1-.633-1.551l6.264-6.264a10.8 10.8 0 0 0-4.855-.921 8.046 8.046 0 0 1 1.6-1.531ZM1.824 13.085l10.04-10.04-.183 2.367-8.765 8.765a8.056 8.056 0 0 1-1.092-1.092ZM4.223 15.054l8.186-8.186a12.306 12.306 0 0 1 2.082 5.81 8.046 8.046 0 0 1-1.531 1.6 10.801 10.801 0 0 0-.921-4.856l-6.264 6.264a7.943 7.943 0 0 1-1.552-.632Z",
    fill: "#FFDF37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmpIcon);
export default __webpack_public_path__ + "static/media/dmp_icon.3dc88913.svg";
export { ForwardRef as ReactComponent };